const EVENT_MARKER = 'kravenVariantInstantV1';

if (!window[EVENT_MARKER]) {
  window[EVENT_MARKER] = true;
  document.addEventListener('change', handleVariantChange, true);
}

/** @param {Event} event */
function handleVariantChange(event) {
  const target = event.target;
  if (!(target instanceof HTMLInputElement || target instanceof HTMLSelectElement)) return;

  const picker = target.closest('variant-picker[data-template-product-match="true"]');
  if (!(picker instanceof HTMLElement) || target.closest('product-card, quick-add-dialog')) return;

  const selected = target instanceof HTMLSelectElement ? target.selectedOptions[0] : target;
  const variantId = selected?.dataset.variantId;
  if (!variantId) return;

  const cacheNode = picker.querySelector('script[data-kraven-variant-cache]');
  if (!cacheNode?.textContent) return;

  try {
    const payload = JSON.parse(cacheNode.textContent);
    const variant = payload?.variants?.find((item) => String(item.id) === String(variantId));
    if (!variant) return;

    picker.dataset.kravenInstantVariantId = String(variant.id);
    updatePrices(picker, payload.productId, variant);
    updateInventory(picker, payload.productId, variant);
    updateProductForm(picker, variant);
  } catch (error) {
    console.warn('[kraven-variant-instant] Unable to apply cached variant:', error);
  }
}

/**
 * @param {HTMLElement} picker
 * @returns {Element | null}
 */
function getScope(picker) {
  return picker.closest('.shopify-section, dialog');
}

/**
 * @param {HTMLElement} picker
 * @param {string | number} productId
 * @param {Record<string, any>} variant
 */
function updatePrices(picker, productId, variant) {
  if (variant.hasVolumePricing || variant.hasUnitPrice) return;

  const scope = getScope(picker);
  if (!scope) return;

  const prices = scope.querySelectorAll(`product-price[data-product-id="${CSS.escape(String(productId))}"]`);
  for (const productPrice of prices) {
    const container = productPrice.querySelector('[ref="priceContainer"]');
    if (!container) continue;

    const price = document.createElement('span');
    price.className = variant.compareAtPrice > variant.price ? 'price-item__group price' : 'price';

    if (variant.compareAtPrice > variant.price) {
      const saleLabel = document.createElement('span');
      saleLabel.className = 'visually-hidden';
      saleLabel.textContent = `${productPrice.dataset.saleLabel || 'Sale price'} `;
      price.append(saleLabel, document.createTextNode(String(variant.priceFormatted || '')));

      const compare = document.createElement('span');
      compare.className = 'price-item__group price-item--regular compare-at-price';
      const regularLabel = document.createElement('span');
      regularLabel.className = 'visually-hidden';
      regularLabel.textContent = `${productPrice.dataset.regularLabel || 'Regular price'} `;
      compare.append(regularLabel, document.createTextNode(String(variant.compareAtPriceFormatted || '')));

      const priceGap = document.createTextNode(' ');
      if (productPrice.dataset.showSalePriceFirst === 'true') container.replaceChildren(price, priceGap, compare);
      else container.replaceChildren(compare, priceGap, price);
    } else {
      price.textContent = String(variant.priceFormatted || '');
      container.replaceChildren(price);
    }

    const installmentInput = productPrice.querySelector('form.payment-terms input[name="id"]');
    if (installmentInput instanceof HTMLInputElement) {
      installmentInput.value = String(variant.id);
      installmentInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
}

/**
 * @param {HTMLElement} picker
 * @param {string | number} productId
 * @param {Record<string, any>} variant
 */
function updateInventory(picker, productId, variant) {
  const scope = getScope(picker);
  const inventory = scope?.querySelector(`product-inventory[data-product-id="${CSS.escape(String(productId))}"]`);
  if (!(inventory instanceof HTMLElement)) return;

  const quantity = Number(variant.inventoryQuantity || 0);
  const threshold = Number(inventory.dataset.inventoryThreshold || 10);
  let status = '';

  if (variant.inventoryManagement === 'shopify') {
    if (quantity > 0) status = quantity <= threshold ? (quantity <= 4 ? 'fast' : 'low') : 'in_stock';
    else if (variant.inventoryPolicy === 'deny') status = 'out_of_stock';
  }

  if (!status) {
    inventory.hidden = true;
    return;
  }

  inventory.hidden = false;
  for (const className of Array.from(inventory.classList)) {
    if (className.startsWith('product-inventory--')) inventory.classList.remove(className);
  }
  inventory.classList.add(`product-inventory--${status}`);

  const icon = inventory.querySelector('.product-inventory__icon');
  if (icon) {
    for (const className of Array.from(icon.classList)) {
      if (className.startsWith('product-inventory__icon-')) icon.classList.remove(className);
    }
    icon.classList.add(`product-inventory__icon-${status}`);
  }

  const text = inventory.querySelector('.product-inventory__text');
  if (!text) return;

  if (status === 'fast' || status === 'low') {
    const strong = document.createElement('strong');
    strong.textContent = status === 'fast' ? 'Selling fast' : 'Ready to ship';
    const divider = document.createElement('span');
    divider.className = 'product-inventory__divider';
    divider.setAttribute('aria-hidden', 'true');
    const detail = document.createElement('span');
    detail.textContent =
      inventory.dataset.showInventoryQuantity === 'true'
        ? status === 'fast'
          ? `Only ${quantity} left`
          : `${quantity} in stock`
        : 'Available now';
    text.replaceChildren(strong, divider, detail);
  } else {
    text.textContent =
      status === 'in_stock' ? inventory.dataset.inStockLabel || 'In stock' : inventory.dataset.outOfStockLabel || 'Out of stock';
  }
}

/**
 * @param {HTMLElement} picker
 * @param {Record<string, any>} variant
 */
function updateProductForm(picker, variant) {
  const scope = getScope(picker);
  const input = scope?.querySelector('product-form-component input[name="id"]');
  if (input instanceof HTMLInputElement) input.value = String(variant.id);
}
